import React from 'react'

const TimeAtar = (props) => {
  const { hours, minutes } = props;
  return (
    <div>
      <span style={{ fontSize: '24px', fontWeight: '300' }}>
        {hours}
      </span>
      
      <span style={{ fontSize: '16px', verticalAlign: 'top'}}>
        {minutes}
      </span>      
    </div>
  )
}

export default TimeAtar
